import React, { Component } from 'react';
import {
  withStyles, CssBaseline, Paper, Typography, Button,
} from '@material-ui/core';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Drawer from '../components/Drawer';
import SearchUserForm from '../components/SearchUserForm';
import styles from '../assets/styles/jss/Home';
import SearchTherapist from '../components/SearchTherapist';
import MultipleSelectOptions from '../components/MultipleSelectOptions';
import SelectedOptions from '../components/SelectedOptions';
import Actions from '../actions';

import classes from '../assets/styles/css/TherapistAssign.module.css';

class TherapistAssign extends Component {
  constructor(props) {
    super(props);
    this.state = {
      therapist: null,
      assignedUsers: [],
    };
    this.presentUsers = [];
  }

  therapistSelected=(therapist) => {
    this.props.fetchAssignedUsers(therapist._id).then(() => {
      const assignedUsers = this.props.assignedUsers;
      this.setState({
        therapist,
        assignedUsers,
      });
      this.presentUsers = assignedUsers.map((user) => { return user._id.toString(); });
    });
  }

  deassignUser =(index) => {
    this.setState((prevState) => {
      const assignedUsers = prevState.assignedUsers;
      assignedUsers.splice(index, 1);
      return {
        assignedUsers,
      };
    });
    this.presentUsers.splice(index, 1);
  }

  selectUser=() => {
    const user = this.props.user;
    if (!this.presentUsers.includes(user._id.toString())) {
      this.setState((prevState) => {
        const assignedUsers = prevState.assignedUsers;
        assignedUsers.push(user);
        return { assignedUsers };
      });
      this.presentUsers.push(user._id.toString());
    }
  }

  resetState=() => {
    this.setState({
      therapist: null,
      assignedUsers: [],
    });
    this.props.resetTherapists();
  }

  submit=() => {
    const assignedUsers = this.state.assignedUsers.map((assignedUser) => { return assignedUser._id; });
    const therapist = this.state.therapist._id;
    const data = { therapist, assignedUsers };
    this.props.assignUsersToTherapists(data).then(
      () => {
        return this.resetState();
      },
    ).catch((err) => {
      console.log(err);
      alert('Oops! Something Went Wrong!');
    });
  }

  getTherapistUi=() => {
    if (!this.state.therapist) {
      return (
        <>
          <CssBaseline />
          <div className={[classes.root, classes.flex, classes.columnFlex, classes.center].join(' ')}>
            <SearchTherapist />
            <MultipleSelectOptions item="therapists" therapistSelected={(therapist) => { this.therapistSelected(therapist); }} />
          </div>
        </>
      );
    }
    return (
      <div className={[classes.flex, classes.root, classes.parentDiv].join(' ')}>
        <Paper className={classes.paper}>
          <div className={[classes.columnFlex, classes.flex].join(' ')}>
            <div>
              <Typography variant="h6">
                {this.state.therapist.name}
              </Typography>
              <Typography variant="caption" display="block" gutterBottom>
                {this.state.therapist.email}
              </Typography>
              <Typography variant="subtitle2" gutterBottom style={{ textAlign: 'start' }}>
                Assigned Users :
              </Typography>
              {this.state.assignedUsers.length > 0
                ? <SelectedOptions selectedUsers={this.state.assignedUsers} deselectUser={(index) => { this.deassignUser(index); }} />
                : <Typography variant="subtitle1" gutterBottom>No users Assigned to this Therapist Yet!</Typography>}
            </div>
            <div className={classes.flex}>
              <Button variant="contained" color="secondary" onClick={this.resetState}>
                Cancel
              </Button>
              <Button variant="contained" color="primary" onClick={this.submit}>
                Assign
              </Button>
            </div>
          </div>
        </Paper>
        <SearchUserForm userSelected={this.selectUser} />
      </div>
    );
  }

  render() {
    return (
      <Drawer>
        {this.getTherapistUi()}
      </Drawer>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch);
}

function mapStateToProps(state) {
  return {
    therapists: state.therapist.allTherapists,
    assignedUsers: state.therapist.assignedUsers,
    user: state.user.data,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(TherapistAssign));
